<template>
    <div>
        <div class="row g-mb-40 div-spacing-top">
            <div v-for="(frame, key) in frameList" :key="key" class="col-lg-3 g-mb-30">
                <article>
                    <div class="gray-border">
                        <swiper :options="frame.swiperOptionSingle" class="swiper-wrapper">
                            <swiper-slide v-for="(pic, index) in frame.imageUrl" :key="index">
                                <div v-on:click="ShowFrameModal(frame.imageUrl, index)" class="location_img swiper-slide">
                                    <div v-if="frame.isOutOfStock[index] || frame.isLowStock[index]" class="stock-banner">
                                        <label class="stock-text">
                                            <span>Low Stock</span>
                                        </label>
                                    </div>
                                    <div class="frame-pic-div" :class="{ 'lowstock': frame.isLowStock[index], 'nostock': frame.isOutOfStock[index] }">
                                        <img class="img-fluid image-align-vert-hor" v-on:error="ImageExists(pic, key, index)" v-bind:src="pic" alt="Loading image...">
                                    </div>
                                </div>
                            </swiper-slide>
                            <div v-bind:id="frame.idList.prevEl" class="level3-gallery-prev swiper-button-prev" slot="button-prev"></div>
                            <div v-bind:id="frame.idList.nextEl" class="level3-gallery-next swiper-button-next" slot="button-next"></div>
                        </swiper>
                    </div>
                    <div class="g-brd-x g-brd-gray-light-v3 g-bg-white gray-border">
                        <swiper :options="swiperOption" class="swiper-wrapper">
                            <swiper-slide v-for="(pic, index) in frame.imageUrl" :key="index">
                                <div class="location_img swiper-slide gray-border overflow-hidden">
                                    <div v-if="frame.isOutOfStock[index] || frame.isLowStock[index]" class="stock-banner-sm">
                                        <label class="stock-text-sm">
                                            <span>Low Stock</span>
                                        </label>
                                    </div>
                                    <div class="center frame-thumbnail-div" :class="{ 'lowstock': frame.isLowStock[index], 'nostock': frame.isOutOfStock[index] }">
                                        <img class="img-fluid image-align-vert-hor" v-bind:src="pic" alt="Loading image...">
                                    </div>
                                    <!-- RemoveImage(key, index) -->
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <div class="g-pa-25 gray-border frame-list-description1-height">
                        <label class="g-font-weight-600 frame-label">Name:</label>
                        <span class="frame-description">{{frame.name}}</span><br>
                        <label class="g-color-text g-font-weight-500 mb-1 frame-label">Color: </label>
                         <span v-for="(color, index) in frame.color" :key="index">{{color}}<span v-if="!(index == frame.color.length - 1)">, </span></span>
                        <br>
                        <label class="g-color-text g-font-weight-500 frame-label mb-1">Frame Type: </label>
                        <span class="g-color-text frame-description mb-1">{{frame.frameType}} </span>
                        <br>
                        <label class="g-color-text g-font-weight-500 frame-label mb-1">Measurements: </label>
                        <br>
                        <span class="frame-description">{{frame.eyeSize}} - {{frame.dbl}} - {{frame.templeLength}}</span>
                        <br>
                    </div>
                    <div class="g-pa-25 gray-border frame-list-description2-height">
                        <label class="g-color-text g-font-weight-500 frame-label mb-1">Manufacturer: </label>
                        <span class="g-color-text frame-description mb-1">{{frame.manufacturer}} </span><br>
                        <label class="g-color-text g-font-weight-500 frame-label mb-1">Brand: </label>
                        <span class="g-color-text frame-description mb-1">{{frame.frameBrand}} </span>
                    </div>
                </article>
            </div>
        </div>
        <frame-modal v-if="isModalShown" :images="selectedImages" :imageIndex="imageIndex" @close="ToggleModal()" ></frame-modal>
    </div>
</template>
<script>
import FrameModal from "@/components/portal/frameResources/frameComponents/FrameModal";
export default {
    components: {FrameModal},
    props:['frameList'],
    data() {
        return {
            swiperOption: {
                direction: "horizontal",
                slidesPerView: 3,
                spaceBetween: 0,
            },
            isModalShown:false,
            selectedImages:'',
            imageIndex: 0
        }
    },
    methods: {
        ToggleModal(){
           this.isModalShown = !this.isModalShown;
        },
        ShowFrameModal(images, index){
           this.selectedImages = images;
           this.imageIndex = index;
           this.ToggleModal();
        },
        RemoveImage(key, index){
            this.frameList[key].imageUrl.splice(index, 1);
        },
        ImageExists(pic, key, index){
            this.frameList[key].imageUrl[index] = '../../../../../static/assets/img/evf-frame.png';
            var _this = this;
            var imageArray = _this.RemoveNullImages(_this.frameList[key].imageUrl);
            _this.frameList[key].imageUrl = imageArray;
        },
        RemoveNullImages(images) {
            return images.filter(e => e != "NULL");
        },
        CheckEVFFrames(evfFrames) {
            var retValue = false;
            evfFrames.forEach(frame => {
                if(frame){
                    retValue = true;
                }
            });
            return retValue;
        }
    },
    created(){
        //this.AddSwiperOptions();
        this.frameList.forEach(frame => {
            frame.imageUrl = this.RemoveNullImages(frame.imageUrl);
        });
    }
}
</script>



// WEBPACK FOOTER //
// FrameList.vue?9555b064